import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import {
  Grid,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Button,
} from '@material-ui/core';

import Snackbar from 'Snackbar';
import axios from 'Axios';
import CloseBtn from '../../../components/CloseBtn';
import RepsAndTraders from './RepsAndTraders';

const InviteWrapper = styled.div`
  padding: 0 30px;
`;

class InviteCompanyUsers extends Component {
  state = {
    role: '',
    email: '',
    inviting: false,
    openSnackbar: false,
    msg: '',
    refresh: false,
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  inviteUser = () => {
    if (!this.state.role || !this.state.email) {
      this.setState({
        openSnackbar: true,
        msg: 'Both Role and Email are required',
      });
    } else {
      this.sendIvitation();
    }
  };

  showSnackbar = msg => {
    this.setState({ msg, openSnackbar: true });
  };

  sendIvitation = () => {
    this.setState({ refresh: false, inviting: true });
    axios
      .post('invite', { email: this.state.email, role: this.state.role })
      .then(response => {
        this.showSnackbar('The invitation has been sent');
        this.setState({ refresh: true, inviting: false, email: '', role: '' });
      })
      .catch(error => {
        const msg = error.response
          ? error.response.data.message.split('exception:')[1]
          : 'Failed to connect to the database';
        this.showSnackbar(msg);
        this.setState({ refresh: false, inviting: false });
      });
  };

  render() {
    const { email, role, inviting, openSnackbar, msg } = this.state;
    const { onClose, profile } = this.props;
    const missingRequired = !email || !role;

    return (
      <Fragment>
        <div className="u-mrg-bot-30">
          <CloseBtn onClick={onClose} />
          <InviteWrapper>
            <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">
              Invite company users
            </h2>
          </InviteWrapper>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel
                  htmlFor="companyName"
                  classes={{ root: 'label--c-gray' }}
                >
                  Email:
                </InputLabel>
                <Input
                  classes={{ underline: 'underline--c-light' }}
                  id="companyName"
                  name="email"
                  type="email"
                  value={email}
                  onChange={this.handleChange}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="outlined-role">Role</InputLabel>
                <Select
                  value={role}
                  onChange={this.handleChange}
                  input={
                    <Input
                      name="role"
                      id="outlined-role"
                      classes={{ underline: 'underline--c-light' }}
                    />
                  }
                >
                  {/* // TO DO odkomentarisi kad bude spreman BE */}
                  {/* <MenuItem value="MANUFACTURER">Manufacturer</MenuItem> */}
                  <MenuItem value="AGENT">Agent</MenuItem>
                  <MenuItem value="DISTRIBUTOR">Distributor</MenuItem>
                  <MenuItem value={'REPRESENTATIVE'}>Representative</MenuItem>
                </Select>
              </FormControl>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  className="t-weight-b pointer u-mrg-right-0 u-mrg-top-60 u-mrg-bot-60"
                  onClick={this.inviteUser}
                  disabled={missingRequired || inviting}
                >
                  Send invitation
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <RepsAndTraders
          companyId={profile ? profile.companyId : null}
          refresh={this.state.refresh}
          showSnackbar={this.showSnackbar}
        />

        <Snackbar
          open={openSnackbar}
          onClose={this.handleCloseSnackbar}
          msg={msg}
        />
      </Fragment>
    );
  }
}

export default InviteCompanyUsers;
